import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import styled from "@emotion/styled";
import { useFormAccordo } from "./ContextAccordo";
import { NumericFormat } from "react-number-format";
import {
  LOGO_MAX_SIZE,
  LOGO_TIPI,
  erroreLogo,
  logoCambiato,
} from "./lib/logo";
import AutocompleteSelect from "./lib/AutocompleteSelect";

const Impostazioni = () => {
  const { formState, dispatch } = useFormAccordo();
  const [erroreFileLogo, setErroreFileLogo] = useState("");
  const logo = formState.impostazioni.logo || { nome: "", file: "" };
  const logoModificato = logoCambiato(logo, formState.logoSalvato);
  const errNomeLogo = erroreLogo(logo, formState.logoSalvato);

  const setLogo = (valori) =>
    dispatch({
      type: "set_impostazioni",
      payload: { logo: { ...logo, ...valori } },
    });

  // Legge l'immagine come data URL (base64) da inviare nella payload
  const handleLogoChange = (e) => {
    const file = e.target.files?.[0];
    e.target.value = ""; // permette di riselezionare lo stesso file
    if (!file) return;
    if (!LOGO_TIPI.includes(file.type)) {
      setErroreFileLogo("Il logo deve essere un'immagine PNG o JPG.");
      return;
    }
    if (file.size > LOGO_MAX_SIZE) {
      setErroreFileLogo("Il logo supera la dimensione massima di 2 MB.");
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      setErroreFileLogo("");
      setLogo({ file: reader.result });
    };
    reader.onerror = () => setErroreFileLogo("Errore nella lettura del file.");
    reader.readAsDataURL(file);
  };

  // Ripristina l'ultimo logo salvato
  const handleLogoAnnulla = () => {
    setErroreFileLogo("");
    dispatch({
      type: "set_impostazioni",
      payload: { logo: formState.logoSalvato },
    });
  };

  return (
    <>
      <Box display="flex" flexDirection="column" m={0}>
        <FormControlLabel
          control={
            <Checkbox
              checked={
                formState.impostazioni.calcolaRimorchio === 1 ? true : false
              }
              onChange={(e) =>
                dispatch({
                  type: "set_impostazioni",
                  payload: {
                    calcolaRimorchio: e.target.checked ? 1 : 0,
                  },
                })
              }
              name="calcolaRimorchio"
            />
          }
          label="Calcola anche con Rimorchio (solo autocarro >= 35t)"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={
                formState.impostazioni.conSenzaIncasso === 1 ? true : false
              }
              onChange={(e) =>
                dispatch({
                  type: "set_impostazioni",
                  payload: {
                    conSenzaIncasso: e.target.checked ? 1 : 0,
                  },
                })
              }
              name="conSenzaIncasso"
            />
          }
          label="Con incasso"
        />
      </Box>
      <Grid
        container
        spacing={3}
        mt={2}
        wrap="wrap"
        sx={{ maxWidth: { xs: "calc(100vw - 60px)" } }}
      >
        <Grid item sm={3} xs={12}>
          <AutocompleteSelect
            id="frazionamento"
            label="Frazionamento"
            options={formState.options.frazionamento}
            value={formState.impostazioni.idFrazionamento}
            onChange={(value) =>
              dispatch({
                type: "set_impostazioni",
                payload: { idFrazionamento: value },
              })
            }
          />
        </Grid>
        <Grid item sm={3} xs={12}>
          <NumericFormat
            size="small"
            margin="none"
            label="% Frazionamento"
            fullWidth
            customInput={TextField}
            suffix="%"
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={0}
            valueIsNumericString
            value={formState.impostazioni.frazionamentoValore}
            onValueChange={(e) =>
              dispatch({
                type: "set_impostazioni",
                payload: {
                  frazionamentoValore: e.value,
                },
              })
            }
          />
        </Grid>
        <Grid item sm={3} xs={12}>
          <AutocompleteSelect
            id="calcoloScadenza"
            label="Calcolo Scadenza"
            options={formState.options.tipoScadenza}
            value={formState.impostazioni.idTipoScadenza}
            onChange={(value) =>
              dispatch({
                type: "set_impostazioni",
                payload: { idTipoScadenza: value },
              })
            }
          />
        </Grid>
        <Grid item sm={3} xs={12}>
          <TextField
            size="small"
            margin="none"
            label="Max Giorni Scadenza"
            required
            fullWidth
            value={formState.impostazioni.valoreScadenza}
            id="valoreScadenza"
            onChange={(e) =>
              dispatch({
                type: "set_impostazioni",
                payload: {
                  valoreScadenza: e.target.value,
                },
              })
            }
            /* error={state.errorNumeroPolizza} */
          />
        </Grid>
        <Grid item sm={3} xs={12}>
          <AutocompleteSelect
            id="utenteGesAcc"
            label="Utente Gestione Accordo"
            options={formState.options.utenteGestione}
            value={formState.impostazioni.idUtenteGestione}
            onChange={(value) =>
              dispatch({
                type: "set_impostazioni",
                payload: { idUtenteGestione: value },
              })
            }
          />
        </Grid>
        <Grid item sm={3} xs={12}>
          <AutocompleteSelect
            id="tabellaScontoProgressivo"
            label="Tabella Sconto Progressivo"
            options={formState.options.scontiTariffe}
            value={formState.impostazioni.idScontoTariffe}
            onChange={(value) =>
              dispatch({
                type: "set_impostazioni",
                payload: { idScontoTariffe: value },
              })
            }
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6">Logo</Typography>
        </Grid>
        <Grid item sm={3} xs={12}>
          <Box
            sx={{
              height: 120,
              border: "1px dashed #ccc",
              borderRadius: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
            }}
          >
            {logo.file ? (
              <img
                src={logo.file}
                alt={logo.nome || "Logo"}
                style={{ maxWidth: "100%", maxHeight: "100%" }}
              />
            ) : (
              <Typography variant="body2" color="textSecondary">
                Nessun logo
              </Typography>
            )}
          </Box>
        </Grid>
        <Grid item sm={3} xs={12}>
          <Box display="flex" flexDirection="column" gap={2}>
            <TextField
              size="small"
              margin="none"
              label="Nome logo"
              fullWidth
              required={logoModificato}
              value={logo.nome}
              onChange={(e) => setLogo({ nome: e.target.value })}
              error={!!errNomeLogo}
              helperText={errNomeLogo || ""}
            />
            <Box display="flex" gap={2}>
              <Button variant="outlined" component="label">
                {logo.file ? "Cambia immagine" : "Carica immagine"}
                <input
                  hidden
                  type="file"
                  accept={LOGO_TIPI.join(",")}
                  onChange={handleLogoChange}
                />
              </Button>
              {logoModificato && (
                <Button onClick={handleLogoAnnulla}>Annulla</Button>
              )}
            </Box>
            {erroreFileLogo && (
              <Typography variant="body2" color="error">
                {erroreFileLogo}
              </Typography>
            )}
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default Impostazioni;
